import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { createOptionsField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum ProductCategoriesBiFilterKeys {
  level = "level"
}

export enum levelEnum {
  zero = "0",
  one = "1",
  two = "2",
  three = "3"
}

export interface ProductCategoriesBiFilterOpts {
  level: FilterOpts<string>;
}

const messages = defineMessages({
  level: {
    defaultMessage: "Level",
    description: "category level"
  },
  one: {
    defaultMessage: "1",
    description: "category level 1"
  },
  three: {
    defaultMessage: "3",
    description: "category level 3"
  },
  two: {
    defaultMessage: "2",
    description: "category level 2"
  },
  zero: {
    defaultMessage: "0",
    description: "category level 0"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: ProductCategoriesBiFilterOpts
): IFilter<ProductCategoriesBiFilterKeys> {
  return [
    {
      ...createOptionsField(
        ProductCategoriesBiFilterKeys.level,
        intl.formatMessage(messages.level),
        [opts.level.value],
        false,
        [
          {
            label: intl.formatMessage(messages.zero),
            value: levelEnum.zero
          },
          {
            label: intl.formatMessage(messages.one),
            value: levelEnum.one
          },
          {
            label: intl.formatMessage(messages.two),
            value: levelEnum.two
          },
          {
            label: intl.formatMessage(messages.three),
            value: levelEnum.three
          }
        ]
      ),
      active: opts.level.active
    }
  ];
}
